import { Link } from "react-router-dom";
import { SubpageHeader } from "@/components/birthlife/SubpageHeader";
import { Footer } from "@/components/birthlife/Footer";
import { Seo } from "@/lib/seo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="flex min-h-screen flex-col bg-sand">
      <Seo
        title="Page not found"
        description="The page you are looking for has moved or never existed."
        path="/404"
        noindex
      />
      <SubpageHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-24 text-center">
        <div>
          <p data-testid="not-found-code" className="font-outfit text-xs font-semibold uppercase tracking-[0.3em] text-terra">
            404 — Page not found
          </p>
          <h1 className="mt-4 font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl">
            This page has moved <span className="italic text-terra">or never existed.</span>
          </h1>
          <p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-plumsoft">
            The link may be old or mistyped. The journal and consultations are right where you left them.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              data-testid="not-found-home"
              className="rounded-full bg-ink px-7 py-3.5 font-outfit text-sm font-semibold text-sand transition-colors duration-300 hover:bg-terra"
            >
              Go to the homepage
            </Link>
            <Link
              to="/blog"
              data-testid="not-found-blog"
              className="rounded-full border border-ink/20 bg-white px-7 py-3.5 font-outfit text-sm font-semibold text-ink transition-colors duration-300 hover:border-terra hover:text-terra"
            >
              Read the journal
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
